import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AppService } from '../../services/app.service';
import { environment } from 'src/environments/environment';
import { StateService } from 'src/app/services/states.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CustomerService } from 'src/app/services/customer.service';
import { empty } from 'rxjs';
import { isString } from 'util';
import { MatDialog } from '@angular/material';
import { DialogHTML } from '../dialogs-html/dialog-html.component';
import { MessValidemail } from '../dialogs-messages/mess_validemail_dialog.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {

  currentUser:any;
  history:any
  facturationData:any
  facturationDataTotal:number = 0;
  messageErrorFacture: string = "";
  messageErrorCredit: string = "";
  messageErrorAbonnement: string = "";
  tokenauth = "";

  constructor(
    private stateService: StateService,
    private router: Router,
    private formBuilder: FormBuilder,
    private appService: AppService,
    private customerService : CustomerService,
    private cookies: CookieService,
    private cdf: ChangeDetectorRef,
    public dialog: MatDialog,
    public _sanitizer: DomSanitizer
    ) { }

  ngOnInit() {
    this.stateService.user.subscribe((user) => {
      if(user){
        this.currentUser = user;
        this.customerService.getDataFacturation().subscribe((res) => {
          if (res && res.result && res.result.error) {
            this.messageErrorCredit = res.result.error
          } else if (res && res.result) {
            this.messageErrorCredit = ""
            this.facturationData = res.result;
            this.facturationDataTotal = this.facturationData.reduce((acc, val) => acc += val.total, 0);
            
          } else {
            console.log('erreur',res);
          }
        });
        this.customerService.getHistory(/*this.currentUser.ID*/).subscribe((res) => {
          if(res && res.result && res.result.error){
            this.messageErrorFacture = res.result.error
          }else
          if (res && res.result) {
            this.messageErrorFacture = ""
            this.history = res.result;
            
            this.history.forEach(invoice => {
              invoice['is_odoo_invoice'] = true;
            });

            this.currentUser.credits.forEach(credit => {
              if (credit['offert'] > 0) {
                let date = credit['datecreation'].split('T')[0];
                this.history.push({
                  'is_odoo_invoice': false,
                  'invoice_date': date,
                  'comment': credit['commentaire']
                });
              }
            });
            this.history.sort(function(a,b) { 
              return <any>new Date(b.invoice_date) - <any>new Date(a.invoice_date);
            });
          } else {
            console.log('erreur',res);
          }
        });
      } else {
        this.router.navigateByUrl("/homepage");
      }
    });
  }

  goBack(){
    this.router.navigateByUrl("/signup");
  }

  viewFacture(facture){
    let url = facture.access_base.replace(/\/$/, '') + facture.access_url + '?is_iframe=1&access_token=' + facture.access_token;
    const dialogRef = this.dialog.open(DialogHTML, {
      data: this._sanitizer.bypassSecurityTrustHtml('<iframe src="'+url+'" style="height: 85vh; width: 78vw"></iframe>'),
    });
  }
}
